module.exports = __webpack_public_path__ + "5cdea566f8546aac93e6d6e08a3d9f70.jpg";